// Feature flags for the public site. The values live in features.json so that Node build
// scripts (sitemap) read the same switch. Flip at build time; there is no runtime toggle.
import features from "./features.json";

// Ramsey is not launched. While false, its route redirects home and its cards, links, metadata,
// sitemap entry, llms.txt entry and ai-manifest entry are absent.
export const RAMSEY_ENABLED = features.ramseyEnabled;
